module.exports = "<ion-app>\n   \n    <ion-router-outlet main>\n\n    </ion-router-outlet>\n\n\n</ion-app>\n\n\n\n"